import { H2, H3, P } from "../components/typography";

export function TermsOfService() {
  return (
    <div
      style={{
        flexDirection: "column",
        alignContent: "center",
        textAlign: "start",
      }}
    >
        <H2>Terms of Service</H2>
  
  <H2>1. Use of Application</H2>
  <P>Convo is intended to provide language coaching and instruction via an artificial intelligence system. The user is granted limited access to use the application for personal language learning purposes only. The user agrees to use the application in compliance with the rules and regulations set forth by Convo.</P>

  <H2>2. Termination of Services</H2>
  <P>Convo reserves the right to terminate services at any time, with or without notice to the user, for any reason including but not limited to violation of the TOS. Any funds paid for a subscription service will not be refunded in the event of termination.</P>

  <H2>3. Subscription Prices</H2>
  <P>Convo reserves the right to adjust subscription prices at any time during the subscription process. Prices may vary by location and are subject to change without notice. The user will be notified of any price changes in advance of their next billing cycle.</P>

  <H2>4. User Privacy</H2>
  <P>Convo takes user privacy seriously and is committed to providing a secure and safe environment for all users. User data will be stored and used in compliance with our Privacy Policy.</P>

  <H2>5. User Content</H2>
  <P>Convo is not responsible for any user-generated content posted within the application. Users are responsible for ensuring that their content does not violate any laws or infringe on the rights of others.</P>

  <H2>6. Intellectual Property</H2>
  <P>Convo owns all intellectual property rights associated with the application and its content, including but not limited to designs, logos, and trademarks. Users are not permitted to copy, modify, reproduce, or distribute any content from the application without express written permission from Convo.</P>

  <P>By using Convo, you agree to all the TOS set forth above. Failure to comply with any of these terms may result in the termination of your account. If you have any questions or concerns regarding our TOS or the application itself, please contact us at <a href="mailto:ilovediscolol@gmail.com">ilovediscolol@gmail.com</a>.</P>
    </div>
  );
}
